import { Text } from "@react-three/drei";

const SberTechDescription = () => {
  return (
    <Text
      position={[0, -0.99, 0]}
      rotation-x={-Math.PI / 2}
      fontSize={0.7}
      color="white"
    >
      {[
        "Role: Software Engineer",
        "Period: 2016 Sep - 2022 July",
        "",
        "Tech stack:",
        "React, Redux, JavaScript, Material UI, Antd",
        "Java, Spring Boot, Docker, Kubernetes, WebSphere MQ",
        "",
        "Achievements:",
        "• IBM Event Bus improvement",
        "• Platform V & SynAI development",
      ].join("\n")}
    </Text>
  );
};

export default SberTechDescription;
